import {
    FETCH_USER_BEGAN,
    FETCH_USER_FAILED,
    FETCH_USER_SUCCESS,
    ADD_BATTERY_TO_USER_BEGAN,
    ADD_BATTERY_TO_USER_SUCCESS,
    ADD_BATTERY_TO_USER_FAILED,
    REMOVE_USER_BEGAN,
    REMOCE_USER_SUCCESS,
    REMOVE_USER_FAILED
} from "../actionTypes/userById";
import axios from "axios";
import * as API from "../../constants/api";
import {userIdSelector} from "../reducers/authReducer";
import {batteryByIdSelector} from "../reducers/batteryByIdReducer";
import {openBatteryIdSelector} from "../reducers/openReducer";
import {
    REMOVE_BATTERY_BEGAN, REMOVE_BATTERY_FAILED,
    REMOVE_BATTERY_FROM_USER_BEGAN,
    REMOVE_BATTERY_FROM_USER_FAILED,
    REMOVE_BATTERY_FROM_USER_SUCCESS, REMOVE_BATTERY_SUCCESS
} from "../actionTypes/batteryById";

export const removeUser = (user_id) => {
    return async (dispatch, getState) => {
        dispatch({
            type: REMOVE_USER_BEGAN
        })

        try {
            console.log('request begin ', API.removeUser())
            let response = await axios.post(API.removeUser(),{user_id:user_id}, {headers: API.defaultHeaders})
            console.log('request end ', response)
            dispatch({
                type: REMOCE_USER_SUCCESS,
                payload: null
            })

        }catch(error){
            dispatch({
                type: REMOVE_USER_FAILED,
                payload: error
            })
        }
    }
}


export const addBatteryToUser = (id,sn) => {
return async (dispatch, getState) => {
    dispatch({
        type: ADD_BATTERY_TO_USER_BEGAN
    })

    try {
        console.log('request begin ', API.addBatteryToUser())
        let response = await axios.post(API.addBatteryToUser(),{user_id:id,sn:sn}, {headers: API.defaultHeaders})
        console.log('request end ', response)
        dispatch({
            type: ADD_BATTERY_TO_USER_SUCCESS,
            payload: null
        })

    }catch(error){
        dispatch({
            type: ADD_BATTERY_TO_USER_FAILED,
            payload: error
        })
    }
}
}

export const fetchUserById = id => {
    return async (dispatch, getState) => {
        dispatch({
            type: FETCH_USER_BEGAN
        })

        try {
            console.log('request begin ', API.getUser(id))
            let response = await axios.get(API.getUser(id), {headers: API.defaultHeaders})
            console.log('request end ', response)

            dispatch({
                type: FETCH_USER_SUCCESS,
                payload: response.data.element
            })

        }catch(error){
            dispatch({
                type: FETCH_USER_FAILED,
                payload: error
            })
        }
    }
}